import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material/material.module';
import { ToolbarComponent } from './shared/components/toolbar/toolbar.component';
import { SidenavComponent } from './shared/components/sidenav/sidenav.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { LoginComponent } from './features/authentication/login/login.component';
import { ChangePasswordComponent } from './features/authentication/change-password/change-password.component';
import { ForgotPasswordComponent } from './features/authentication/forgot-password/forgot-password.component';
import { UserProfileComponent } from './features/authentication/user-profile/user-profile.component';
import { HomeComponent } from './shared/components/home/home.component';
import { PharmacySearchComponent } from './features/pharmacy/pharmacy-search/pharmacy-search.component';
import { PharmacyAddComponent } from './features/pharmacy/pharmacy-add/pharmacy-add.component';
import { PharmacyViewComponent } from './features/pharmacy/pharmacy-view/pharmacy-view.component';
import { TransactionSearchComponent } from './features/transaction/transaction-search/transaction-search.component';
import { TransactionDetailComponent } from './features/transaction/transaction-detail/transaction-detail.component';
import { TransactionViewComponent } from './features/transaction/transaction-view/transaction-view.component';
import { TransactionSummaryComponent } from './features/transaction/transaction-summary/transaction-summary.component';
import { TransactionFlowComponent } from './features/transaction/transaction-flow/transaction-flow.component';
import { RoleAddComponent } from './features/user-management/role/role-add/role-add.component';
import { RolePermissionsComponent } from './features/user-management/role/role-permissions/role-permissions.component';
import { RoleSearchComponent } from './features/user-management/role/role-search/role-search.component';
import { RoleViewComponent } from './features/user-management/role/role-view/role-view.component';
import { UserAddComponent } from './features/user-management/user/user-add/user-add.component';
import { UserRolesComponent } from './features/user-management/user/user-roles/user-roles.component';
import { UserSearchComponent } from './features/user-management/user/user-search/user-search.component';
import { UserViewComponent } from './features/user-management/user/user-view/user-view.component';
import { PermissionAddComponent } from './features/user-management/permission/permission-add/permission-add.component';
import { PermissionSearchComponent } from './features/user-management/permission/permission-search/permission-search.component';
import { PermissionViewComponent } from './features/user-management/permission/permission-view/permission-view.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import { MatTooltipModule} from '@angular/material/tooltip';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormControl,FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatspinnerComponent } from './shared/components/matspinner/matspinner.component';
import { ToastrModule } from 'ngx-toastr';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthModule } from '@okta/okta-angular';
import { environment } from 'src/environments/environment';
import { AccessTokenInterceptor } from './core/guards/access-token-interceptor';
import { TransactionService } from './services/transactionservice';
import { MatTreeModule } from '@angular/material/tree';
import { UnAuthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { PharmacyStoreComponent } from './features/pharmacy/pharmacy-store/pharmacy-store.component';
import { PharmacyUpdateComponent } from './features/pharmacy/pharmacy-update/pharmacy-update.component';
import { PharmacyStoreSearchComponent } from './features/pharmacy/pharmacy-store-search/pharmacy-store-search.component';
import { PharmacyStoreSyncSearchComponent } from './features/pharmacy/pharmacy-store-sync-search/pharmacy-store-sync-search.component';
import { VendorAddComponent } from './features/vendor/vendor-add/vendor-add.component';
import { VendorSearchComponent } from './features/vendor/vendor-search/vendor-search.component';
import { VendorUpdateComponent } from './features/vendor/vendor-update/vendor-update.component';
import { ConnectionDetailsComponent } from './features/connection/connection-details/connection-details.component';
import { CdkFixedSizeVirtualScroll } from "@angular/cdk/scrolling";
const oktaAuth = new OktaAuth(environment.oidc);
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    SidenavComponent,
    ToolbarComponent,
    PharmacyAddComponent,
    TransactionSearchComponent,
    TransactionDetailComponent,
    LoginComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    UserProfileComponent,
    PharmacyViewComponent,
    TransactionViewComponent,
    TransactionSummaryComponent,
    TransactionFlowComponent,
    UserSearchComponent,
    UserAddComponent,
    UserViewComponent,
    UserRolesComponent,
    RolePermissionsComponent,
    PharmacySearchComponent,
    RoleAddComponent,
    RoleSearchComponent,
    RoleViewComponent,
    PermissionAddComponent,
    PermissionSearchComponent,
    PermissionViewComponent,
    MatspinnerComponent,
    UnAuthorizedComponent,
    PharmacyStoreComponent,
    PharmacyUpdateComponent,
    PharmacyStoreSearchComponent,
    PharmacyStoreSyncSearchComponent,
    VendorAddComponent,
    VendorSearchComponent,
    VendorUpdateComponent,
    ConnectionDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgbModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    HttpClientModule,
    FormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgbTimepicker,
    ToastrModule.forRoot(),
    MatTreeModule,
    CdkFixedSizeVirtualScroll
],
  providers: [TransactionService,{provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true},DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }